module.exports = __webpack_public_path__ + "img/tairitsu_grievous_lady.1a7e311a.png";